function GetSessionProperties() {
}

module.exports = GetSessionProperties;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/get-session-properties.js
// module id = 471
// module chunks = 1